<template>
    <!--begin::Dashboard-->
    <div class="row">
        <div class="col-md-12 col-lg-12 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto" data-aos="fade-up" data-aos-delay="100">
            <div class="card card-custom gutter-b">
									<div class="card-header flex-wrap border-0 pt-6 pb-0">
										<div class="card-title">
											<h3 class="card-label">Clientes
											<span class="d-block text-muted pt-2 font-size-sm">Lista de clientes registrados en la plataforma</span></h3>
										</div>
										<div class="card-toolbar">
											<!--begin::Button-->
                      <router-link
                          class="btn btn-primary font-weight-bolder"
                          :to="{ name: 'create-client' }"
                        >
											<span class="svg-icon svg-icon-md">
												<!--begin::Svg Icon | path:/metronic/theme/html/demo1/dist/assets/media/svg/icons/Design/Flatten.svg-->
												<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
													<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
														<rect x="0" y="0" width="24" height="24"></rect>
														<circle fill="#000000" cx="9" cy="15" r="6"></circle>
														<path d="M8.8012943,7.00241953 C9.83837775,5.20768121 11.7781543,4 14,4 C17.3137085,4 20,6.6862915 20,10 C20,12.2218457 18.7923188,14.1616223 16.9975805,15.1987057 C16.9991904,15.1326658 17,15.0664274 17,15 C17,10.581722 13.418278,7 9,7 C8.93357256,7 8.86733422,7.00080962 8.8012943,7.00241953 Z" fill="#000000" opacity="0.3"></path>
													</g>
												</svg>
												<!--end::Svg Icon-->
											</span>Nuevo Cliente</router-link>

                       <download-excel 
          class="download"
          style="margin-left:10px; margin-right:0 !important"
            :data="clients"
            :fields="json_fields"
            worksheet="Clientes"
            name="Clientes.xls">
           <i class="far fa-file-excel"></i> Descargar
          </download-excel>
											<!--end::Button-->
										</div>
									</div>
									<div class="card-body">
										<!--begin: Search Form-->
										<!--begin::Search Form-->
										<div class="mb-7">
											<div class="row align-items-center">
												<div class="col-lg-9 col-xl-8">
													<div class="row align-items-center">
														<div class="col-md-6 my-2 my-md-0">
															<div class="input-icon">
																<input type="text" class="form-control" v-model="search" placeholder="Buscar..." id="kt_datatable_search_query">
																<span>
																	<i class="flaticon2-search-1 text-muted"></i>
																</span>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<!--end::Search Form-->
										<!--begin: Datatable-->
                    <v-data-table
                      :headers="headers"
                      :items="clients"
                      :search="search"
                      hide-default-footer
                      :items-per-page="itemsPerPage"
                      :page.sync="page"
                      @page-count="pageCount = $event"
                    >
                    <template v-slot:item="row">
                    <tr>
                      <td style="min-width:140px">{{row.item.rutClienteCompleto}}</td>
                      <td style="min-width:190px">{{row.item.nombres}}</td>
                      <td style="min-width:140px">{{row.item.apellidos}}</td>
                      <td>{{row.item.rutEmpresa}}-{{row.item.dvEmpresa}}</td>
                      <td>{{row.item.nombreEmpresa}}</td>
                      <td>{{row.item.formaPago}}</td>
                      <td>{{row.item.canalCliente}}</td>
                      <td>{{row.item.email}}</td>
                                <td>{{row.item.activo ? 'Activo' : 'No Activo'}}</td>
                                 <td> {{row.item.nombresUsuarioCreador}} {{row.item.apellidosUsuarioCreador}} </td>
                      <td>{{formatDate(row.item.fechaCreacion)}}</td>
                      
                      <td style="min-width:140px">
                         <router-link :to="{ name: 'edit-client', params: { token: row.item.tokenCliente }}" class="btn btn-sm btn-clean btn-icon">
                            <i class="la la-edit"></i>
                        </router-link>
                          <a v-on:click.prevent="confirmDelete(row.item)" class="btn btn-sm btn-clean btn-icon" title="Eliminar">
                            <i class="la la-trash"></i>
                          </a>						
                      </td>
                    </tr>
                    </template>
                    </v-data-table>
                    <v-pagination v-model="page" :length="pageCount"></v-pagination>
										<!--end: Datatable-->
									</div>
								</div>

        </div>
        <v-dialog
            v-model="dialog"
            max-width="290"
          >
            <v-card>
              <v-card-title class="headline">Está seguro de eliminar el cliente?</v-card-title>

              <v-card-text>
                El cliente será eliminado. En caso que el cliente posee pagos en el sistema, el cliente será deshabilitado, no eliminado
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="green darken-1"
                  text
                  @click="dialog = false"
                >
                  Cancelar
                </v-btn>

                <v-btn
                  color="green darken-1"
                  text
                  @click="deleteClient"
                >
                  Aceptar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </div>
    <!--end::Dashboard-->
</template>


<script>

import { mapState } from "vuex";
import { GET_CLIENTS, DELETE_CLIENT } from "@/core/services/store/client.module";
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
//import {Money} from 'v-money'

import { validationMixin } from "vuelidate";
import {
  minLength
} from "vuelidate/lib/validators";

import moment from 'moment'
moment.locale( 'es' );

export default {
  mixins: [validationMixin],
  name: "dashboard",
  components: {/*Money,*/},
  data() {
    return {
       json_fields: {
        "Rut": "rutClienteCompleto",
        "Nombre Cliente": "nombres",
        "Apellidos": "apellidos",
        "Rut Empresa":"rutEmpresaCompleto",
        "Empresa": "nombreEmpresa",
        "Forma Pago": "formaPago",
        "Canal Cliente": "canalCliente",
        "Email": "email",
        "Activo": "activoFormateado",
        'Usuario Creador':'nombresUsuarioCreador',
        "Fecha Creacion": "fechaCreacionFormateada"
       },
      dialog:false,
      tokenDelete:'',
      page: 1,
        pageCount: 0,
        itemsPerPage: 20,

      menu2:false,
      menu1:false,
      hasta: null,
      desde:null,
      search: '',
      headers: [
        { text: 'Rut', value: 'rutCliente'},
        { text: 'Nombre Cliente', value: 'nombres'},
        { text: 'Apellidos', value: 'apellidos' },
        { text: 'Rut Empresa', value: 'rutEmpresa'},
        { text: 'Empresa', value: 'nombreEmpresa'},
        { text: 'Forma Pago', value: 'formaPago'},
        { text: 'Canal Cliente', value: 'canalCliente'},
        { text: 'Email', value: 'email' },
        { text: 'Activo', value: 'activo' },
        { text: 'Usuario Creador', value: 'nombresUsuarioCreador'},
        { text: 'Fecha Creacion', value: 'fechaCreacion' },
        {text:'Acciones'}
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      },
      form: {
        documento: "",
        
        desde: "",
        hasta: ""
      },
    };
  },
  mounted () {
    this.getClients();
  },
  validations: {
      form: {
        documento: {
          minLength: minLength(3)
        },
        desde: {
          
        },
        hasta: {

        }
      }
    },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        documento: null,
        sucursal: null,
        desde: null,
        hasta: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onButtonClick(item) {
      console.log('click on ' + item.no)
    },
    getClients() {
      this.$Progress.start();
      this.$store
          .dispatch(GET_CLIENTS, this.$store.state.auth.user)
          .then(()=>{this.$Progress.finish()});
    },
     formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },
    confirmDelete(item){
      this.tokenDelete= item.tokenCliente;
      this.dialog = true;
    },
    deleteClient() {
      this.$Progress.start();
      this.$store
          .dispatch(DELETE_CLIENT, this.tokenDelete)
          .then(()=>{this.$Progress.finish(), this.getClients(),this.dialog = false});
    }
  },
  filters:{
    formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },

    formatTime(value) {
        const hora = moment(value).format('HH:mm:ss');
        return `${hora}`;
    }
  },
  computed: {
    ...mapState({
      clients : state => state.client.clients,
      errors: state => state.errors,
      client: state => state.auth.user,
      
      rutCliente: function(){
        return `${this.order.rutEmpresa}-${this.order.dvEmpresa}`;
      },  
    })
  }
};
</script>
<style>
.container {
    max-width: 1185px !important;
}
.b-form-datepicker {min-width:130px;}
.b-form-datepicker label {
        padding-bottom: 3px !important;
    padding-top: 6px;
    text-transform: none;
    white-space: nowrap !important;
    font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 10px 5px;
}
.d-content-full{width:100%;}

.v-data-table .btn, .card-toolbar .btn {
  border-radius: 0;
     -webkit-box-shadow: none; 
     box-shadow: none; 
     padding: 7px 20px 6px 20px; 
     text-transform: uppercase;
}

.card.card-custom > .card-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    min-height: 70px;
    padding-top: 0;
    padding-bottom: 0;
    background-color: transparent;
}

.card-header:first-child {
    border-radius: calc(0.42rem - 1px) calc(0.42rem - 1px) 0 0;
}
.pt-6, .py-6 {
    padding-top: 1.5rem !important;
}
.pb-0, .py-0 {
    padding-bottom: 0 !important;
}
.flex-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
}
.border-0 {
    border: 0 !important;
}
.card-header {
    padding: 2rem 2.25rem;
    margin-bottom: 0;
    background-color: #ffffff;
    border-bottom: 1px solid #EBEDF3;
}
.btn.btn-primary {
    color: #FFFFFF;
    background-color: #3699FF;
    border-color: #3699FF;
}
.btn:not(.btn-text) {
    cursor: pointer;
}
.btn {
    outline: none !important;
    vertical-align: middle;
    -webkit-transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
    transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
    transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
    transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, -webkit-box-shadow 0.15s ease;
}
.font-weight-bolder {
    font-weight: 600 !important;
}
.btn-primary {
    color: #ffffff;
    background-color: #3699FF;
    border-color: #3699FF;
    -webkit-box-shadow: none;
    box-shadow: none;
}
</style>
